import { useTheme } from './theme-context';
import styles from './ThemeToggle.module.css';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? '切换为亮色模式' : '切换为暗黑模式';

  return <button aria-pressed={isDark} className={styles.button} onClick={toggleTheme} type="button">{label}</button>;
}
